import * as React from 'react'

import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach'
import { NextPage, withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { ErrorCase, InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/product-detail'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../../components/error-props'
import { withCart } from '../../components/hocs/with-cart'
import { getAlgoliaCrossSellConfig } from '../../util/algolia'

import '@grandvisionhq/reviews/dist/index.css'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { routes } = useBloomreachPageRoutes()

  if ('statusCode' in props) {
    // If an error status code was returned, render the error page.
    return null
  }

  const crossSellConfig = getAlgoliaCrossSellConfig(props.product.productType)

  // We need to map appointment-book to book-appointment, since it's hardcoded in core.
  const adjustedRoutes = {
    ...routes,
    'book-appointment': routes['appointment-book'],
  }

  return <Page {...props} crossSellConfig={crossSellConfig} adjustedPageRoutes={adjustedRoutes} colorFeatureIcons="orange" />
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout(),
  withCart({ readOnly: true })
)(ProductDetailPage)
